<div class="ir-plugin th-plugin" *ngIf="plugin">
  <div class="ir-line ir-plugin-title" [ngClass]="{ 'ir-plugin-gray': showBreadcrumbs }">
    <div class="ir-line--right">
      <div
        class="ir-btn"
        *ngIf="showHelpButton"
        [ngClass]="showPluginHelp ? 'th-btn-action' : 'th-btn-normal'"
        (click)="showHidePluginHelp()"
      >
        <span>?</span>
      </div>
      <div
        class="ir-btn"
        [ngClass]="showValidations ? 'th-btn-action' : 'th-btn-normal'"
        [permissions]="[['visible', 'inspection.offline.edit', inspection]]"
        [routerLink]="getEditRoute()"
      >
        <span>{{ (showValidations ? 'common.open' : 'common.edit') | translate }}</span>
      </div>
    </div>
    <div class="ir-line-content">
      <span>
        {{ showBreadcrumbs ? plugin.inspection.name + ' / ' : '' }}
        {{ showBreadcrumbs && plugin.point?.name ? plugin.point?.name + ' / ' : '' }}
        {{ 'plugins.observation.observations' | translate }}</span
      ><!--<strong>- AX87</strong>-->
    </div>
  </div>
  <div class="ir-line ir-plugin-validation" *ngIf="showValidations">
    <table class="ir-plugin-table">
      <tr class="th-plugin-line--content ir-plugin-gray">
        <td class="th-plugin-line--data" >
          <div *ngFor="let message of messages"><span  innerHtml="{{ message | translate: { value: plugin } }}"></span>
      </div>  </td>
      </tr>
    </table>
  </div>
  <div class="ir-plugin-content" *ngIf="showContent">
    <p class="ir-plugin-instruction" *ngIf="showPluginHelp">
      <span>{{ 'plugins.observation.select-and-add-observations' | translate }}</span>
    </p>

    <table class="ir-plugin-table" *ngFor="let item of observationsAndRecommandations">
      <tbody *ngIf="item.Selected">
        <tr class="th-plugin-line--header">
          <td colspan="5">
            <span
              >{{ 'plugins.observation.name' | translate }} : <strong innerHtml="{{ item.Observation }}"></strong
            ></span>
          </td>
        </tr>
        <tr>
          <td colspan="5">
            <span
              >{{ 'plugins.observation.recommandation' | translate }} :
              <strong innerHtml="{{ item.Recommandation }}"></strong
            ></span>
          </td>
        </tr>

        <ng-container *ngFor="let i of item.impacts | keyvalue">
          <tr class="th-plugin-line--content" *ngIf="i.value.enabled">
            <td>
              <span
                >{{ 'plugins.observation.impact' | translate }} :
                <strong class="important">{{
                  'plugins.observation.value.' + i.value.id + '.title' | translate: { default: i.value.name }
                }}</strong></span
              >
            </td>
            <td class="th-plugin-line--value">
              <span
                ><strong class="important">{{ i.value.text }}</strong>
                {{
                  'plugins.observation.value.' + i.value.id + '.boost' | translate: { default: i.value.name + ' boost' }
                }}</span
              >
            </td>
          </tr>
        </ng-container>

        <tr *ngIf="item.Responsible != null">
          <td>
            <span
              >{{ 'plugins.observation.to-take-action' | translate }} :
              <strong>{{ item.Responsible | responsiblespipe }}</strong></span
            >
          </td>
        </tr>
        <tr *ngIf="item.Machines && item.Machines.length > 0">
          <td>
            <span
              >{{ 'plugins.observation.machines' | translate }} :
              <strong *ngFor="let m of item.Machines; let isLast = last"
                >{{
                  m.CustomerEquipementId
                    ? m.Name + ' (' + m.CustomerEquipementId + ')'
                    : m.Name
                    ? m.Name
                    : getMachineName(m)
                }}{{ isLast ? '' : ', ' }}</strong
              ></span
            >
          </td>
        </tr>
        <tr *ngIf="item.Priority != null">
          <td>
            <span
              >{{ 'plugins.observation.priority' | translate }} :
              <strong>{{ item.Priority | prioritiespipe }}</strong></span
            >
          </td>
        </tr>
        <tr *ngIf="item.TimeToRepairs && item.TimeToRepairs.length">
          <td>
            <span>{{ 'plugins.time-to-repair.name' | translate }} :</span>
          </td>
        </tr>
        <tr *ngFor="let timeToRepair of item.TimeToRepairs">
          <td>
            <div class="ir-plugin-values th-plugin-values" *ngIf="timeToRepair && timeToRepair.Reparator != -1">
              <p>
                <span
                  >{{ 'plugins.time-to-repair.repair-will-take' | translate }}
                  <strong class="ir-ph1"
                    >{{ timeToRepair?.Hours | number: '2.0' }}:{{ timeToRepair?.Minutes | number: '2.0' }}
                  </strong>
                  {{ 'plugins.time-to-repair.hours' | translate }} {{ 'plugins.time-to-repair.by' | translate }}
                  <strong class="ir-ph1">{{ timeToRepair?.Reparator | reparatorpipe }}</strong></span
                >
              </p>
            </div>
          </td>
        </tr>
        <tr *ngIf="item.Parts && item.Parts.length">
          <td>
            <span>{{ 'plugins.parts.parts-management' | translate }} :</span>
          </td>
        </tr>
        <tr *ngFor="let part of item.Parts">
          <td>
            <div class="ir-plugin-values th-plugin-values">
              <p>
                <span>{{ part?.Id }}-</span><span>{{ part?.Page }}-</span><span>{{ part?.Position }}-</span
                ><span>{{ part?.PartsName }}</span
                ><span *ngIf="part?.Quantity"
                  ><strong> x {{ part?.Quantity }}</strong></span
                >
              </p>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
